/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
export default function ManualPage() {
  return (
    <div className="grid grid-cols-12 mx-14 gap-6 mt-8 pt-10 ">
      <div className="col-span-12 row-start-1  p-5 bg-white rounded-lg">

        <h1>INDICE</h1>

        <h2>COMPRA</h2>
        <h2>INSTALACIÓN</h2>
        <h2>CONFIGURACIÓN</h2>
        <h2>MENÚ SUPERIOR</h2>
        <h2>INICIO</h2>
        <h2>CONSULTANTE</h2>
        <h2>NUMEROLOGÍA PERSONAL</h2>
        <h2>NUMEROLOGÍA DE PAREJA</h2>
        <h2>NUMEROLOGÍA DE GRUPO</h2>

        <h1>COMPRA</h1>
        <p>1. Ingresa al URL app.numerologia-cotidiana.com . </p>

        <p>2. Da clic en el botón “Ir a Compra". </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/COMPRA1.png" alt="example-img" />

        <p>3. Información de contacto. </p>
        <p>-Si ya es cliente da clic en la opción “Haz clic aquí para acceder". </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/COMPRA2.png" alt="example-img" />
        <p>-Ingrese su nombre de usuario o correo electrónico y contraseña. Si no recuerda su contraseña puede restablecerla, solo de clic en la opción “¿Olvidaste la contraseña?"  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/COMPRA3.png" alt="example-img" />
        <p>
          -Su información de contacto se actualizará.
          *Sugerimos verificar que todos los datos sean correctos y en caso de faltar algún apartado es necesario completarlo.
          {' '}
        </p>

        <p>-Si aún no es cliente, complete la Información de contacto e Información adicional. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/COMPRA4.png" alt="example-img" />
        <p>-Al terminar el formulario puede seleccionar la opción “¿Crear una cuenta?" para sus próximas compras. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/COMPRA5.png" alt="example-img" />

        <p>4. Cupón. </p>
        <p>-Si tiene un cupón de descuento puede canjearlo dando clic en la opción “Haz clic aquí para introducir su código". </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/COMPRA6.png" alt="example-img" />
        <p>-Ingrese el código del cupón en el recuadro y para finalizar de clic en “Aplicar cupón" . </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/COMPRA7.png" alt="example-img" />

        <p>5. Tu pedido. </p>
        <p>Verifique que la información de su pedido sea correcta. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/COMPRA8.png" alt="example-img" />

        <p>6. Pago. </p>
        <p>Seleccione la opción de pago que prefiera. </p>
        <p>-Tarjeta de crédito (Stripe). Ingrese los datos de su tarjeta de crédito a través de Stripe. Puede seleccionar la opción “Guardar la información de pago" para sus futuras compras. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/COMPRA9.png" alt="example-img" />

        <p>-Débito y crédito. Complete los datos de su tarjeta. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/COMPRA10.png" alt="example-img" />
        <p>Puede pagar con las siguientes opciones para tarjetas de crédito o débito. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/COMPRA11.png" alt="example-img" />

        <p>-Efectivo. Seleccione el punto de pago donde quiere realizar el pago indicado. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/COMPRA11.png" alt="example-img" />

        <p>7. Finalizar compra. </p>
        <p>Una vez toda la información este completa y sea correcta solo es necesario dar clic en el botón “Realizar el pedido". </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/COMPRA13.png" alt="example-img" />

        <p>8. Correo confirmación de pedido. </p>
        <p>
          Ingrese al email que proporcionó en su información de compra, verifique que haya recibido el correo de confirmación de su compra.
          Podrás identificarlo con el asunto “¡Hemos recibido tu pedido en Numerología Cotidiana de Laura Rodriguez!".
          {' '}
        </p>

        <h1>INSTALACIÓN</h1>
        <p>Asegúrese de tener en su equipo un descompresor de archivos.  </p>

        <h2>MACOS</h2>
        <p>1. Ingrese al correo de confirmación de pedido y de clic en el enlace para descargar el software. </p>

        <p>2. Descargue el archivo zip. </p>

        <p>3. Al intentar abrir el archivo le aparecerá un mensaje. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/MACOS1.png" alt="example-img" />

        <p>4. De clic derecho y seleccione la opción “Abrir". </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/MACOS2.png" alt="example-img" />

        <p>5. Le aparecerá un cuadro de confirmación, seleccione el botón “Abrir". </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/MACOS3.png" alt="example-img" />

        <h2>WINDOWS</h2>
        <p>1. Ingrese al correo de confirmación de pedido y de clic en el enlace para descargar el software. </p>

        <p>2. Descargue el archivo zip. </p>

        <p>3. De clic en el archivo para abrir o clic derecho “Extraer aquí". </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/WINDOWS1.jpg" alt="example-img" />

        <p>4. Seleccione la ubicación del software dentro de su equipo. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/WINDOWS2.jpg" alt="example-img" />

        <p>5. Busque el software en la ubicación que seleccionó y de clic para abrir. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/WINDOWS3.jpg" alt="example-img" />

        <h1>CONFIGURACIÓN</h1>
        <p>Ubicada en el menú izquierdo, la opción “Configuración" le permite: </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CONFIGURACION" alt="example-img" />
        <p>
          -Modificar sus datos personales y datos profesionales.
          Al terminar de actualizar todos lo datos de clic en el botón “Guardar"
          {' '}
        </p>
        <p>-Conocer la información y vigencia de su licencia. </p>

        <h1>MENÚ SUPERIOR</h1>

        <h2>INGRESAR DATOS</h2>
        <p>Le redirige al menú “Consultante". Aquí puede buscar, agregar, editar o eliminar datos de los consultantes. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/DATOS.png" alt="example-img" />

        <h2>ACTUALIZAR DATOS</h2>
        <p>
          Le redirige al menú “Consultante". Aquí puede actualizar los datos del consultante seleccionado de una manera rápida.
          También puede buscar, agregar, editar o eliminar datos de los consultantes.
          {' '}
        </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/ACTUALIZAR.png" alt="example-img" />

        <h2>CAMBIAR FECHA</h2>
        <p>Esta opción le permite modificar la fecha para sus consultas y reportes.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CAMBIARFECHA.png" alt="example-img" />

        <h2>DATOS DE PAREJA</h2>
        <p>Le redirige al menú “Numerología de Pareja". Puede agregar o eliminar parejas así como tener acceso rápido a los apartados de este menú. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/PAREJA.png" alt="example-img" />

        <h2>DATOS DE GRUPO</h2>
        <p>Le redirige al menú “Numerología de Grupo". Puede agregar o eliminar personas al grupo así como tener acceso rápido a los apartados de este menú. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/GRUPO.png" alt="example-img" />

        <h2>GUARDAR REPORTE</h2>
        <p>Este botón le permite guardar un archivo PDF correspondiente al reporte de la página en que se encuentre.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/REPORTE.png" alt="example-img" />
        <p>
          *El botón guardar reporte no se habilitará hasta que:
          -Seleccione un consultante
          -Seleccione un consultante y su pareja
          -Seleccione un consultante y su grupo
          {' '}
        </p>

        <h2>IMPRIMIR REPORTES</h2>
        <p>Puede seleccionar los reportes que desee descargar un solo archivo PDF. Esta opción es útil si le interesa guardar más de un reporte. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/IMPRIMIR.png" alt="example-img" />

        <h1>INICIO</h1>
        <p>Al ingresar podrá ver el menú principal “Inicio". En este apartado visualizará la información de la fecha actual de consulta correspondiente a Energía Universal y Energía Personal.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/INICIO1.jpg" alt="example-img" />

        <h1>CONSULTANTE</h1>
        <p>En el menú “Consultante" puede buscar, agregar, editar o eliminar datos de los consultantes.  </p>

        <h2>INGRESAR DATOS</h2>
        <p>Existen dos maneras de añadir a un nuevo Consultante. </p>
        <p>-Menú superior: Clic en el ícono “Ingresar Datos". Complete la información y de clic en el botón “Guardar".  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/DATOSC1.png" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CONSULTANTE2.jpg" alt="example-img" />
        <p>-Menú izquierdo: En el ícono Consultante.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CONSULTANTE1.jpg" alt="example-img" />
        <p>
          Ingrese la información solicitada y haga clic en el botón “Guardar".
          Nombre(s), apellido paterno, apellido materno, fecha de nacimiento, empresa, teléfono y correo electrónico son datos obligatorios. Mientras que, nacionalidad y sexo son datos opcionales.
          {' '}
        </p>

        <p>Una vez haya guardado la información, en la parte derecha de la pantalla le aparecerá la información del “Perfil del consultante" que recién se añadió. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CONSULTANTE3.jpg" alt="example-img" />

        <h2>BUSCAR, EDITAR Y ELIMINAR CONSULTANTES </h2>
        <p>
          En el apartado de “Historial" puede realizar las siguientes acciones:
          Ícono lupa: buscar por nombre
          ícono lápiz: editar datos de cada consultante
          ícono basurero: eliminar consultantes
          {' '}
        </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CONSULTANTE4.jpg" alt="example-img" />

        <h1>NUMEROLOGÍA PERSONAL</h1>
        <p>Antes de comenzar, asegúrese de seleccionar al consultante deseado. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CONSULTANTE.png" alt="example-img" />

        <p>Al seleccionar el menú “Numerología Personal" se despliegan las opciones que incluye este apartado. Para ingresar a cada opción es necesario dar clic sobre el texto o ícono. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/PINACULO1.png" alt="example-img" />

        <p>-Pináculo: Se encuentra la información correspondiente a Nombre, Potencial Frecuencial, Pináculo, Puente de etapa, Retornos anuales y Curva del tiempo.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/PINACULO2.jpg" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/PINACULO3.jpg" alt="example-img" />
        <p>*Los botones “Comprobación" que se muestran en la información Nombre y Pináculo funcionan para comprobación de los números maestros. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/COMPROBACION1.png" alt="example-img" />

        <p>-Camino de Vida: Se encuentra la información correspondiente a Ciclo de 9 años, Etapa de Aprendizaje y Línea de Jerarquía del Diálogo Energético. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CAMINO1.jpg" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CAMINO2.png" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CAMINO3.png" alt="example-img" />

        <p>-Nombre: Se encuentra la información correspondiente a Valores Numéricos del Nombre, Potencial Frecuencial del Nombre, Desglose del Nombre, Nombre Activo, Ciclo del Nombre, Equilibrio de Planos Existenciales y Tabla de inclusión. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/NOMBRE1.jpg" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/NOMBRE2.jpg" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/NOMBRE3.jpg" alt="example-img" />

        <p>-Crear Nombre: En el primer apartado “Crear Nombre" por default mostrará la información del consultante. Puede editar este apartado para consultar el nombre y fecha de nacimiento (persona, empresa, marca, etc) que le interese. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CREARNOMBRE1.jpg" alt="example-img" />
        <p>Se encuentra la información correspondiente a Valores Numéricos del Nombre, Pináculo, Tabla de inclusión, Desglose del Nombre y Retornos Anuales. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CREARNOMBRE2.jpg" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CREARNOMBRE3.jpg" alt="example-img" />

        <p>-Tabla del Destino: Se encuentra la información correspondiente a Tabla del Destino y Valores Numéricos del Nombre. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/DESTINO1.jpg" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/DESTINO2.png" alt="example-img" />

        <p>-Vibración del Tiempo: Se encuentra la información correspondiente a Energías Activas, Cuatrimestres por meses, Ciclo de 9 años, Cuatrimestres por Año y Análisis del Tiempo. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/<VIBRACION1.jpg" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/VIBRACION2.jpg" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/VIBRACION3.jpg" alt="example-img" />
        <p>*Puede cambiar la fecha para consultar otros resultados. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CAMBIOFECHA.jpg" alt="example-img" />

        <p>-Retornos Anuales: Se encuentra la información correspondiente a Curva del Tiempo. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/RETORNOS1.jpg" alt="example-img" />
        <p>*Puede cambiar la fecha para consultar otros resultados. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CAMBIOFECHA.jpg" alt="example-img" />

        <p>-Círculo del Tiempo: Se encuentra la información correspondiente a Circulo del Tiempo. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CIRCULO1.jpg" alt="example-img" />
        <p>*Puede cambiar la fecha para consultar otros resultados. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CAMBIOFECHA.jpg" alt="example-img" />

        <p>-Calendario Anual: Podrá consultar el calendario anual numerológico de la fecha en consulta. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/ANUAL1.png" alt="example-img" />
        <p>*Puede cambiar la fecha para consultar otros resultados. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CAMBIOFECHA.jpg" alt="example-img" />

        <p>-Calendario Mensual: Podrá consultar el calendario mensual numerológico de la fecha en consulta. Cambia el mes en el menú desplegable. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/MENSUAL1.png" alt="example-img" />
        <p>*Puede modificar la fecha para consultar otros resultados. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CAMBIOFECHA.jpg" alt="example-img" />

        <h1>NUMEROLOGÍA DE PAREJA</h1>
        <h2>AÑADIR DATOS DE PAREJA</h2>
        <p>Es importante mencionar que cada Consultante tiene sus propios Datos de Pareja, por lo cual es necesario ingresar la información por consultante. </p>

        <p>Existen dos maneras de añadir los Datos de Pareja. </p>
        <p>-Menú superior: En el ícono “Datos de Pareja".  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/DATOSP1.png" alt="example-img" />
        <p>De clic en el botón “Agregar Pareja", complete la información y guarde.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/DATOSP3.png" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/DATOSP2.jpg" alt="example-img" />

        <p>-Menú izquierdo: En cualquiera de las opciones que se incluyen en el ícono “Numerología de Pareja".  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/DATOSP3.png" alt="example-img" />
        <p>De clic en el botón “Agregar Pareja",complete la información y guarde.  </p>

        <p>*En el ícono del basurero puede eliminar parejas registradas. El sistema requiere de confirmación para borrar permanentemente a la pareja seleccionada. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/ELIMINAR1.jpg" alt="example-img" />

        <h2>CONSULTAS</h2>
        <p>Asegúrese de seleccionar al consultante deseado para continuar. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CONSULTANTE1.png" alt="example-img" />

        <p>Al seleccionar el menú “Numerología de Pareja" se despliegan las opciones que incluye este apartado. Para ingresar a cada opción es necesario dar clic sobre el texto o ícono. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/PAREJA1.png" alt="example-img" />

        <p>Para continuar debe seleccionar una pareja. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/ANALISIS1.png" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/ANALISIS2.png" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/ANALISIS3.png" alt="example-img" />

        <p>-Análisis: Se encuentra la información correspondiente a Nombre, Pináculo y Retornos de pareja e individual.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/ANALISIS4.png" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/ANALISIS5.png" alt="example-img" />

        <p>-Vibración de Tiempo: Se encuentra la información correspondiente a Energías Activas, Cuatrimestres por meses, Cliclo de 9 años, Cuatrimestre por Año y Curva del Tiempo.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/VIBRACIONP1.png" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/VIBRACIONP2.png" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/VIBRACIONP3.png" alt="example-img" />

        <p>-Retornos Anuales: Se encuentra la información correspondiente a Retornos.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/RETORNOSP1.png" alt="example-img" />

        <p>-Tabla del Destino P.: Se encuentra la información correspondiente a Tabla del Destino de la Pareja.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/DESTINOP1.png" alt="example-img" />

        <p>-Tabla Compatibilidad: Se encuentra la información correspondiente a Tabla de Compatibilidad.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/COMPATIBILIDADP1.png" alt="example-img" />

        <h1>NUMEROLOGÍA DE GRUPO</h1>
        <h2>AÑADIR DATOS DE GRUPO</h2>
        <p>Es importante mencionar que cada Consultante tiene sus propios Datos de Grupo, por lo cual es necesario ingresar la información por consultante. </p>

        <p>Existen dos maneras de añadir los Datos de Grupo. </p>
        <p>-Menú superior: En el ícono “Datos de Grupo".  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/DATOSG1.png" alt="example-img" />
        <p>De clic en el botón “Agregar al Grupo", complete la información y guarde.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/DATOSG3.jpg" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/DATOSG2.png" alt="example-img" />
        <p>*En el botón superior derecho puede cancelar la acción.  </p>

        <p>-Menú izquierdo: En cualquiera de las opciones que se incluyen en el ícono Numerología de Grupo.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/DATOSG4.png" alt="example-img" />
        <p>De clic en el botón “Agregar al Grupo", complete la información y guarde.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/DATOSG3.jpg" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/DATOSG2.png" alt="example-img" />
        <p>*En el botón superior derecho puede cancelar la acción.  </p>

        <p>*En el ícono del basurero puede eliminar integrantes del grupo registrados. El sistema requiere de confirmación para borrar permanentemente al integrante seleccionado. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/ELIMINAR2.jpg" alt="example-img" />

        <h2>CONSULTAS</h2>
        <p>Asegúrese de seleccionar al consultante deseado. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/CONSULTANTE2.png" alt="example-img" />

        <p>Al seleccionar el menú “Numerología de Grupo" se despliegan las opciones que incluye este apartado. Para ingresar a cada opción es necesario dar clic sobre el texto o ícono. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/GRUPO1.png" alt="example-img" />

        <p>Verifique que tenga todas las personas que desea consultar en el grupo. </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/GRUPO2.png" alt="example-img" />

        <p>-Pináculo: Se encuentra la información correspondiente a Nombre, Pináculo y Retornos de grupo e individual.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/PINACULOG1.png" alt="example-img" />

        <p>-Vibración del Tiempo: Se encuentra la información correspondiente a Energías Activas, Cuatrimestre por meses, Ciclo de 9 años, Líneas de Jerarquía del Diálogo Energético, Cuatrimestre por Año y Curva del tiempo.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/VIBRACIONG1.png" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/VIBRACIONG2.png" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/VIBRACIONG3.png" alt="example-img" />
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/VIBRACIONG4.png" alt="example-img" />

        <p>-Retornos Anuales: Se encuentra la información correspondiente a Retornos.  </p>
        <img src="https://app.numerologia-cotidiana.com/wp-content/uploads/2022/09/RETORNOSG1.png" alt="example-img" />

      </div>
    </div>

  );
}
